// Function include
// 	- Setting label for Simple Card

import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import { TextField } from '@mui/material';
import SliderWithInput from '../SliderWithInput';
import { textFieldStyleProps } from '../GridAndAxes/GridAndAxes';
import {
  updateCardControls,
  callQueryAPI,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { RootState } from '../../../redux';
import { useDispatch } from 'react-redux';

const ChartLabel = ({
  iconColor,
  backgroundColor,
}: {
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const dispatch = useDispatch();
  const { chartControls, tabTileProps, chartProperties } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
  }));
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  const cardControls = chartControls.properties[propKey].cardControls;

  let generateLabelName =
    chartControls.properties[propKey].cardControls.generateLabelName || 'Auto';

  let labelNameOptions: any[] = [
    {
      type: 'Auto',
      title: 'Reset Label Name Automatically',
      description: 'In auto mode, label name is generated automatically based on fields dropped.',
    },

    {
      type: 'Manual',
      title: 'Click to Set Label Name Manually',
      description:
        "In manual mode, user can manually change the label name and it's no more dynamic with changing fields.",
    },
  ];

  const selectedLabelOption = labelNameOptions.find((option) => option.type === generateLabelName);
  const currentDescription = selectedLabelOption ? selectedLabelOption.description : null;

  const UpdateLabelNameOption = (optionType: string) => {
    dispatch(updateCardControls(propKey, 'generateLabelName', optionType));
  };

  const RenderLabelNameOptions = () =>
    labelNameOptions.map((option: any) => {
      const isSelected = option.type === generateLabelName;
      return (
        <div
          key={option.type}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          onClick={() => UpdateLabelNameOption(option.type)}
          title={option.title}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '6px 10px',
            minHeight: '28px',
            flex: '1 1 0%',
          }}
        >
          {option.type}
        </div>
      );
    });

  return (
    <React.Fragment>
      <div className="optionsInfo">
        <div
          className="optionDescription"
          style={{
            paddingLeft: '0.6rem',
            marginTop: '10px',
            color: iconColor ? iconColor : '#404040',
          }}
        >
          LABEL NAME
        </div>
        <div className="radioButtons" style={{ marginTop: '2px', alignItems: 'flex-start' }}>
          <RenderLabelNameOptions />
        </div>

        {currentDescription && (
          <div className="radioButtons" style={{ marginTop: '0px' }}>
            <div
              className="descriptionBox"
              style={{
                padding: '8px 10px',
                fontSize: '12px',
                color: iconColor ? iconColor : '#333',
                backgroundColor: backgroundColor ? backgroundColor : '#f9f9f9',
                border: '1px solid #ddd',
                borderRadius: '4px',
                lineHeight: '1.4',
                width: '100%',
              }}
            >
              {currentDescription}
            </div>
          </div>
        )}

        {generateLabelName === 'Manual' && (
          <div
            style={{
              width: '100%',
              padding: '10px 0 0 0',
              fontSize: '12px',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              transition: 'ease-in 0.3s linear',
            }}
          >
            <div
              className="optionDescription"
              style={{
                paddingLeft: '0.6rem',
                marginTop: '-8px',
                color: iconColor ? iconColor : '#404040',
              }}
            >
              Set Label Name
            </div>
            <TextField
              value={chartControls.properties[propKey].cardControls.subText}
              variant="outlined"
              onChange={(e: any) => {
                const newValue = e.target.value;
                dispatch(updateCardControls(propKey, 'subText', newValue));
                dispatch(updateCardControls(propKey, 'renameForVisual', newValue));
              }}
              InputProps={{
                ...textFieldStyleProps,
                sx: {
                  color: iconColor ? iconColor : '#404040',
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2bb9bb',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'lightgray',
                  },
                },
              }}
              style={{ marginRight: '-0.3rem' }}
            />
          </div>
        )}
        <div style={{ marginBottom: '10px', marginTop: '-10px' }}>
          <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
            Label Font Size
          </div>
          <SliderWithInput
            percent={false}
            sliderValue={cardControls.subtextFontSize}
            sliderMinMax={{ min: 10, max: 70, step: 1 }}
            changeValue={(value) => dispatch(updateCardControls(propKey, 'subtextFontSize', value))}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateCardControls: (propKey: string, option: string, value: any) =>
      dispatch(updateCardControls(propKey, option, value)),
  };
};

export default ChartLabel;
